import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import moment from 'moment'

import { useStores } from 'admin/hooks'
import CustomDataGrid from 'admin/components/data-grid'

const formatDateTime = (value) => (value ? moment(value).format('YYYY-MM-DD HH:mm') : '-')

const getDriverRouteRowId = (row, index) =>
  row.id ||
  row.bookingId ||
  row.jobId ||
  `${row.driverId || 'driver'}-${row.date || 'date'}-${row.timeWindow || 'slot'}-${index}`

const columns = [
  { field: 'jobId', headerName: 'Booking / Job ID', minWidth: 160 },
  { field: 'customerName', headerName: 'Customer Name', minWidth: 170 },
  { field: 'address', headerName: 'Address', minWidth: 260, flex: 1 },
  {
    field: 'jobType',
    headerName: 'Address / Job Type',
    minWidth: 170,
    valueGetter: (params) => params.row.addressType || params.row.jobType || '-',
  },
  { field: 'date', headerName: 'Date', minWidth: 120 },
  { field: 'timeWindow', headerName: 'Time Window', minWidth: 170 },
  {
    field: 'newOrderCreatedTime',
    headerName: 'New Order Created',
    minWidth: 180,
    valueGetter: (params) => formatDateTime(params.row.newOrderCreatedTime),
  },
  {
    field: 'invoiceCompletedTime',
    headerName: 'Invoice Completed',
    minWidth: 180,
    valueGetter: (params) => formatDateTime(params.row.invoiceCompletedTime),
  },
  { field: 'driverAssigned', headerName: 'Driver Assigned', minWidth: 160 },
  { field: 'postalCode', headerName: 'Postal Code', minWidth: 120 },
  { field: 'areaName', headerName: 'Area / District', minWidth: 180 },
  {
    field: 'repeatedAreaCluster',
    headerName: 'Repeat Cluster',
    minWidth: 160,
    valueGetter: (params) =>
      params.row.isRepeatedAreaCluster
        ? `Repeated (${params.row.repeatedAreaClusterSize || 0})`
        : '-',
  },
]

const DriverRouteDataGrid = () => {
  const { reportStore } = useStores()

  const handlePageChange = useCallback((page) => {
    reportStore.updateDriverRoutePage(page)
  }, [])

  const handlePageSizeChange = useCallback((perPage) => {
    reportStore.updateDriverRouteRowsPerPage(perPage)
  }, [])

  return (
    <CustomDataGrid
      rows={reportStore.driverRouteFilteredRows}
      columns={columns}
      rowCount={(reportStore.driverRouteFilteredRows || []).length}
      pageSize={reportStore.driverRouteRowsPerPage}
      page={reportStore.driverRouteCurrentPage}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      loading={reportStore.driverRouteLoading}
      rowsPerPageOptions={[20, 50, 100]}
      getRowId={getDriverRouteRowId}
    />
  )
}

export default observer(DriverRouteDataGrid)
